export const contractorConstants = {
  BASE_PATH: '/v1/contractors',
};
